export default {"src":"/_next/static/media/guard.1587242f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};